var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaylistPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "play-button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.8,
    height: 39.8,
    viewBox: "0 0 39.8 39.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_429",
    "data-name": "Grupo 429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_428",
    "data-name": "Grupo 428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_843",
    "data-name": "Caminho 843",
    d: "M19.9,0A19.9,19.9,0,1,0,39.8,19.9,19.922,19.922,0,0,0,19.9,0Zm0,38.142A18.242,18.242,0,1,1,38.142,19.9,18.262,18.262,0,0,1,19.9,38.142Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_844",
    "data-name": "Caminho 844",
    d: "M204.886,156.926l-11.608-7.463a.829.829,0,0,0-1.278.7v14.925a.829.829,0,0,0,1.278.7l11.608-7.463a.829.829,0,0,0,0-1.394Zm-11.228,6.641V151.679l9.246,5.943Z",
    transform: "translate(-177.075 -137.723)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistPlay);
export default __webpack_public_path__ + "static/media/playlist-play.362c0ccb1c129c9ec504139246d813a5.svg";
export { ForwardRef as ReactComponent };